import { render, staticRenderFns } from "./84.vue?vue&type=template&id=709652ff&scoped=true&"
import script from "./84.vue?vue&type=script&lang=js&"
export * from "./84.vue?vue&type=script&lang=js&"
import style0 from "./84.vue?vue&type=style&index=0&id=709652ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709652ff",
  null
  
)

export default component.exports